import React, { useState } from 'react';
import { Card, Select, message } from 'antd';
import {
  ApiOutlined, CloudServerOutlined, DatabaseOutlined, GlobalOutlined,
  SafetyCertificateOutlined, EditOutlined,
} from '@ant-design/icons';
import { useListServersQuery, useEditProjectMutation } from '../store/api';

export const SERVER_ROLES = [
  { key: 'servidor_api_id', label: 'API', icon: <ApiOutlined />, color: '#0168fa' },
  { key: 'servidor_web_id', label: 'Web', icon: <CloudServerOutlined />, color: '#00b8d4' },
  { key: 'servidor_api_failover_id', label: 'API Failover', icon: <SafetyCertificateOutlined />, color: '#fd7e14' },
  { key: 'servidor_web_failover_id', label: 'Web Failover', icon: <SafetyCertificateOutlined />, color: '#fd7e14' },
  { key: 'servidor_bd_id', label: 'BD principal', icon: <DatabaseOutlined />, color: '#10b759' },
  { key: 'servidor_bd_consulta_id', label: 'BD consulta', icon: <DatabaseOutlined />, color: '#00cccc' },
  { key: 'servidor_bd_failover_id', label: 'BD Failover', icon: <DatabaseOutlined />, color: '#042893' },
  { key: 'servidor_dns_id', label: 'DNS', icon: <GlobalOutlined />, color: '#f10075' },
];

const RoleRow = ({ role, proyecto, servers, onSaved }) => {
  const [editing, setEditing] = useState(false);
  const [editProject, { isLoading }] = useEditProjectMutation();

  const serverId = proyecto[role.key];
  const nameKey = role.key.replace('_id', '_nombre');
  const ipKey = role.key.replace('_id', '_ip');
  const live = servers.find(s => Number(s.id) === Number(serverId));
  const nombre = live?.nombre || proyecto[nameKey];
  const ip = (live?.ip || proyecto[ipKey] || '').trim();

  const save = async (value) => {
    try {
      await editProject({ id: proyecto.id, [role.key]: value ?? '' }).unwrap();
      message.success(`${role.label} actualizado`);
      onSaved?.();
    } catch {
      message.error('Error al guardar');
    }
    setEditing(false);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 0',
        borderBottom: '1px solid #f5f6fa',
      }}
    >
      <div style={{ width: 150, display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        <span style={{ color: role.color }}>{role.icon}</span>
        <span style={{ fontWeight: 600, fontSize: 13 }}>{role.label}</span>
      </div>
      <div style={{ flex: 1 }}>
        {editing ? (
          <Select
            autoFocus
            open
            showSearch
            allowClear
            loading={isLoading}
            style={{ width: '100%', maxWidth: 400 }}
            placeholder="Seleccionar servidor..."
            value={serverId || undefined}
            optionFilterProp="label"
            options={servers.map(s => ({ value: s.id, label: `${s.nombre} (${s.ip})` }))}
            onChange={save}
            onBlur={() => setEditing(false)}
          />
        ) : (
          <div
            onClick={() => setEditing(true)}
            style={{
              cursor: 'pointer',
              padding: '6px 10px',
              borderRadius: 8,
              background: serverId ? 'rgba(132,90,223,0.06)' : '#fafafa',
              border: `1px dashed ${serverId ? 'rgba(132,90,223,0.25)' : '#d1d5db'}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            {serverId ? (
              <span>
                <strong>{nombre}</strong>
                <span style={{ color: '#8392a5', marginLeft: 8, fontSize: 12 }}>{ip}</span>
              </span>
            ) : (
              <span style={{ color: '#8392a5' }}>Sin asignar — clic para elegir</span>
            )}
            <EditOutlined style={{ color: '#0168fa', fontSize: 12 }} />
          </div>
        )}
      </div>
    </div>
  );
};

const ProjectServerRoles = ({ proyecto, onUpdated }) => {
  const { data: servers = [] } = useListServersQuery();
  if (!proyecto?.id) return null;

  return (
    <Card
      title={<span><CloudServerOutlined style={{ marginRight: 8 }} />Servidores de infraestructura</span>}
      size="small"
      style={{ marginBottom: 16 }}
    >
      <p style={{ color: '#8392a5', fontSize: 13, marginBottom: 12 }}>
        API, Web, bases de datos, failover y DNS. Clic en cada fila para editar.
      </p>
      {SERVER_ROLES.map(role => (
        <RoleRow key={role.key} role={role} proyecto={proyecto} servers={servers} onSaved={onUpdated} />
      ))}
    </Card>
  );
};

export default ProjectServerRoles;